// type.js

class BaseType {
	values() {
		return Object.values(this).filter(item => typeof item === 'object');
	}

	getCode(text) {
		const item = this.values().find(item => item.text === text);
		return item ? item.code : null;
	}

	getText(code) {
		const item = this.values().find(item => item.code === code);
		return item ? item.text : null;
	}

	getItemByCode(code) {
		return this.values().find(item => item.code === code) || null;
	}
}

class TypeCode extends BaseType {
	constructor(items) {
		super();
		Object.assign(this, items);
	}
}

export const userTypeCode = new TypeCode({
	customer: { code: 'UserType.customer', text: '고객' },
	designer: { code: 'UserType.designer', text: '디자이너' },
});
export const userTypeCodes = userTypeCode.values();

export const userStatusTypeCode = new TypeCode({
	unknown: { code: 'UserStatusType.unknown', text: '미확인' },
	temp: { code: 'UserStatusType.temp', text: '임시 가입(정보 입력 전)' },
	active: { code: 'UserStatusType.active', text: '정상' },
	dormant: { code: 'UserStatusType.dormant', text: '휴면' },
	withdrawn: { code: 'UserStatusType.withdrawn', text: '탈회' },
	blacklisted: { code: 'UserStatusType.blacklisted', text: '블랙리스트' },
	removed: { code: 'UserStatusType.removed', text: '관리자 삭제' },
});
export const userStatusTypes = userStatusTypeCode.values();

export const sendUserTypeCode = new TypeCode({
	all: { code: 'SendUserType.all', text: '전체' },
	manage: { code: 'SendUserType.manage', text: '매니저' },
	designer: { code: 'SendUserType.designer', text: '디자이너' },
});
export const sendUserTypes = sendUserTypeCode.values();

export const targetUserTypeCode = new TypeCode({
	all: { code: 'TargetUserType.all', text: '전체' },
	designer: { code: 'TargetUserType.designer', text: '디자이너', relatedUserType: userTypeCode.designer },
	customer: { code: 'TargetUserType.customer', text: '고객', relatedUserType: userTypeCode.customer },
});
export const targetUserTypes = targetUserTypeCode.values();

export const sendMethodTypeCode = new TypeCode({
	all: { code: 'SendMethodType.all', text: '전체' },
	push: { code: 'SendMethodType.push', text: '푸시' },
	sms: { code: 'SendMethodType.sms', text: '메시지' },
});
export const sendMethodTypes = sendMethodTypeCode.values();

export const sendPeriodTypeCode = new TypeCode({
	immediately: { code: 'SendPeriodType.immediately', text: '즉시' },
	appointment: { code: 'SendPeriodType.appointment', text: '예약' },
});
export const sendPeriodTypes = sendPeriodTypeCode.values();

export const designerAuthStatusTypeCode = new TypeCode({
	unknown: { code: 'DesignerAuthStatusType.unknown', text: '미확인' },
	preAuth: { code: 'DesignerAuthStatusType.preAuth', text: '미인증' },
	authComplete: { code: 'DesignerAuthStatusType.authComplete', text: '승인' },
	authReject: { code: 'DesignerAuthStatusType.authReject', text: '반려' },
	authWait: { code: 'DesignerAuthStatusType.authWait', text: '대기' },
});
export const designerAuthStatusTypes = designerAuthStatusTypeCode.values();

export const designerAccountBrandTypeCode = new TypeCode({
	unknown: { code: 'DesignerAccountBrandType.unknown', text: '미확인' },
	kb: { code: 'DesignerAccountBrandType.kb', text: '국민은행' },
	shinhan: { code: 'DesignerAccountBrandType.shinhan', text: '신한은행' },
	nh: { code: 'DesignerAccountBrandType.nh', text: '농협은행' },
	ibk: { code: 'DesignerAccountBrandType.ibk', text: '기업은행' },
	woori: { code: 'DesignerAccountBrandType.woori', text: '우리은행' },
	city: { code: 'DesignerAccountBrandType.city', text: '씨티은행' },
	hana: { code: 'DesignerAccountBrandType.hana', text: '하나은행' },
	kakao: { code: 'DesignerAccountBrandType.kakao', text: '카카오뱅크' },
	toss: { code: 'DesignerAccountBrandType.toss', text: '토스뱅크' },
	k: { code: 'DesignerAccountBrandType.k', text: '케이뱅크' },
});
export const designerAccountBrandTypes = designerAccountBrandTypeCode.values();

export const bannerTypeCode = new TypeCode({
	layer: { code: 'BannerType.layer', text: '레이어' },
	banner: { code: 'BannerType.banner', text: '배너' },
});
export const bannerTypes = bannerTypeCode.values();

export const displayTargetUserTypeCode = new TypeCode({
	all: { code: 'DisplayTargetUserType.all', text: '전체' },
	designer: { code: 'DisplayTargetUserType.designer', text: '디자이너' },
	customer: { code: 'DisplayTargetUserType.customer', text: '고객' },
});
export const displayTargetUserTypes = displayTargetUserTypeCode.values();

export const displayPositionTypeCode = new TypeCode({
	main: { code: 'DisplayPositionType.main', text: '메인' },
	customerList: { code: 'DisplayPositionType.customerList', text: '고객목록' },
});
export const displayPositionTypes = displayPositionTypeCode.values();

export const iconTypeCode = new TypeCode({
	none: { code: 'IconType.none', text: '없음' },
	notice: { code: 'IconType.notice', text: '공지' },
	event: { code: 'IconType.event', text: '이벤트' },
	discount: { code: 'IconType.discount', text: '할인' },
	calendar: { code: 'IconType.calendar', text: '일정' },
	tag: { code: 'IconType.tag', text: '가격 태그' },
});
export const iconTypes = iconTypeCode.values();

export const fontFamilyTypeCode = new TypeCode({
	Cafe24Ssurround: { code: 'FontFamilyType.Cafe24Ssurround', text: 'Cafe24Ssurround' },
	SUIT: { code: 'FontFamilyType.SUIT', text: 'SUIT' },
	SCDream: { code: 'FontFamilyType.SCDream', text: 'SCDream' },
	NotoSans: { code: 'FontFamilyType.NotoSans', text: 'NotoSans' },
});
export const fontFamilyTypes = fontFamilyTypeCode.values();

export const textAlignTypeCode = new TypeCode({
	center: { code: 'TextAlignType.center', text: '중앙' },
	left: { code: 'TextAlignType.left', text: '왼쪽' },
	right: { code: 'TextAlignType.right', text: '오른쪽' },
});
export const textAlignTypes = textAlignTypeCode.values();

export const displayTypeCode = new TypeCode({
	visible: { code: 'DisplayType.visible', text: '노출' },
	hidden: { code: 'DisplayType.hidden', text: '미노출' },
});
export const displayTypes = displayTypeCode.values();

export const displayTimeTypeCode = new TypeCode({
	always: { code: 'DisplayTimeType.always', text: '항상' },
	date: { code: 'DisplayTimeType.date', text: '노출 시작/종료일' },
});
export const displayTimeTypes = displayTimeTypeCode.values();

export const notificationTypeCode = new TypeCode({
	userCancel: { code: 'NotificationType.userCancel', text: '고객 취소' },
	userAppointment: { code: 'NotificationType.userAppointment', text: '고객 예약' },
	userModifyAppointment: { code: 'NotificationType.userModifyAppointment', text: '고객 수정' },
	designerCancel: { code: 'NotificationType.designerCancel', text: '디자이너 취소' },
	designerAppointment: { code: 'NotificationType.designerAppointment', text: '디자이너 예약' },
	designerModifyAppointment: { code: 'NotificationType.designerModifyAppointment', text: '디자이너 수정' },
	confirmAppointment: { code: 'NotificationType.confirmAppointment', text: '고객 예약요청' },
	finishAppointment: { code: 'NotificationType.finishAppointment', text: '시술 완료' },
	authComplete: { code: 'NotificationType.authComplete', text: '면허증 확인 완료' },
	authReject: { code: 'NotificationType.authReject', text: '면허증 반려' },
	authWait: { code: 'NotificationType.authWait', text: '면허증 확인 중' },
	webNotification: { code: 'NotificationType.webNotification', text: '관리자 웹 발송' },
});
export const notificationTypes = notificationTypeCode.values();
